var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLateArrivalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28621 7.37349V3.44554C9.28596 3.27361 9.24082 3.10473 9.15525 2.95561C9.06967 2.80649 8.94664 2.6823 8.79832 2.59535L5.381 0.631374C5.2328 0.545324 5.06448 0.5 4.89311 0.5C4.72174 0.5 4.55341 0.545324 4.40521 0.631374L0.987897 2.59535C0.839051 2.68171 0.715586 2.80576 0.629934 2.95502C0.544283 3.10427 0.499469 3.27346 0.500005 3.44554V7.37453C0.500339 7.54637 0.545525 7.71515 0.631095 7.86417C0.716665 8.01319 0.839653 8.13729 0.987897 8.2242L4.40521 10.1882C4.55341 10.2742 4.72174 10.3196 4.89311 10.3196C5.06448 10.3196 5.2328 10.2742 5.381 10.1882L8.79832 8.2242C8.94724 8.1378 9.07075 8.01367 9.15641 7.86431C9.24206 7.71496 9.28684 7.54566 9.28621 7.37349Z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#315E45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89313 2.30851V5.40952L6.96047 6.44319",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#315E45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLateArrivalIcon);
export default __webpack_public_path__ + "static/media/lateArrivalIcon.d77a58b2b38a436b8877d2cb35195b32.svg";
export { ForwardRef as ReactComponent };